import { configureStore } from '@reduxjs/toolkit';
import rootReducer, { history } from '../reducer';

export {
  history,
};
const store = configureStore({
  reducer: rootReducer,
});
export type RootState = ReturnType<typeof store.getState>;
export default store;
